module.exports = __webpack_public_path__ + "d1a4672d4de6f29e5e70c3a9bce88bea.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/partials/dang-ki-nhan-tin.svg
// module id = ./assets/images/partials/dang-ki-nhan-tin.svg
// module chunks = 0